import { Component, OnInit } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { WindowRef } from "./window/WindowRef";
import { Angulartics2GoogleAnalytics } from "angulartics2/ga";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit {
  constructor(
    angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
    private router: Router,
    private winRef: WindowRef
  ) {
    // start tracking!
    angulartics2GoogleAnalytics.startTracking();
  }

  ngOnInit() {}
}
